import ReactOnRails from 'react-on-rails';

import Jobs from '@components/pages/Jobs/index';

ReactOnRails.register({
  Jobs,
});
